export const ENDPOINTS = {
  adminAuth: {
    login: '/admin/auth/login',
  },
  auth: {
    refresh: '/auth/refresh',
  },
  metrics: {
    platform: '/admin/metrics',
  },
  review: {
    queue: '/admin/review/queue',
    orgs: '/admin/review/orgs',
    orgDetail: (orgId: string) => `/admin/review/orgs/${orgId}`,
    orgTransactions: (orgId: string) => `/admin/review/orgs/${orgId}/transactions`,
    orgMonthlyCloses: (orgId: string) => `/admin/review/orgs/${orgId}/monthly-closes`,
    deleteMonthlyClose: (orgId: string, closeId: string) =>
      `/admin/review/orgs/${orgId}/monthly-closes/${closeId}`,
    updateTransaction: (id: string) => `/admin/review/transactions/${id}`,
  },
  conversations: {
    list: '/conversations',
    detail: (id: string) => `/conversations/${id}`,
    messages: (id: string) => `/conversations/${id}/messages`,
    resolve: (id: string) => `/conversations/${id}/resolve`,
    archive: (id: string) => `/conversations/${id}/archive`,
    draftReply: (id: string) => `/conversations/${id}/draft-reply`,
  },
  queue: {
    summary: '/admin/queue/summary',
    assign: '/admin/queue/assign',
  },
  accounting: {
    entity: (id: string) => `/accounting/entities/${id}`,
  },
  monthlyClose: {
    update: (id: string) => `/monthly-close/${id}`,
    openItems: (id: string) => `/monthly-close/${id}/open-items`,
    bulkSignoff: '/monthly-close/bulk-signoff',
  },
  notifications: {
    list: '/notifications',
  },
  upload: {
    presign: '/upload/presign',
  },
  users: {
    publicProfile: (id: string) => `/users/${id}/public`,
  },
  documents: {
    list: '/documents',
    detail: (id: string) => `/documents/${id}`,
    retry: (id: string) => `/documents/${id}/retry`,
  },
  adminOrgs: {
    extendTrial: (orgId: string) => `/admin/orgs/${orgId}/extend-trial`,
  },
  adminWritebacks: {
    list: '/admin/accounting/writebacks',
    retry: (id: string) => `/admin/accounting/writebacks/${id}/retry`,
  },
  adminReconciliation: {
    queueOrgs: '/admin/reconciliation/queue/orgs',
    queue: (orgId: string) => `/admin/reconciliation/orgs/${orgId}/queue`,
    run: (orgId: string) => `/admin/reconciliation/orgs/${orgId}/run`,
    txCandidates: (orgId: string, transactionId: string) =>
      `/admin/reconciliation/orgs/${orgId}/transactions/${transactionId}/candidates`,
    match: (orgId: string, matchId: string) =>
      `/admin/reconciliation/orgs/${orgId}/matches/${matchId}`,
    matches: (orgId: string) => `/admin/reconciliation/orgs/${orgId}/matches`,
    confirmMatch: (orgId: string, matchId: string) =>
      `/admin/reconciliation/orgs/${orgId}/matches/${matchId}/confirm`,
    rejectMatch: (orgId: string, matchId: string) =>
      `/admin/reconciliation/orgs/${orgId}/matches/${matchId}/reject`,
    bulkConfirm: (orgId: string) => `/admin/reconciliation/orgs/${orgId}/matches/bulk-confirm`,
    rules: (orgId: string) => `/admin/reconciliation/orgs/${orgId}/rules`,
    rule: (orgId: string, ruleId: string) =>
      `/admin/reconciliation/orgs/${orgId}/rules/${ruleId}`,
    unmatchedDocs: (orgId: string) =>
      `/admin/reconciliation/orgs/${orgId}/documents/unmatched`,
  },
} as const;
